module.exports = __webpack_public_path__ + "img/pptx.7111aca8.svg";